module.exports = __webpack_public_path__ + "logo_luna.png?b3371317b092827dcd6a5e484b47db8d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_luna.png
// module id = 48
// module chunks = 0